import React from "react";
import { Link, useHistory } from "react-router-dom";
import { toDate } from "../../../middleware/dates";
import { sortArray, SortBy } from "../../../hooks/useSort";
import { StudentItem } from "../../../models/student";
import { ThSort } from "../../common/ui_elements";
import { isMobile } from "react-device-detect";

type StudentsTableProps = {
  students_data: StudentItem[];
  selectStudent: any;
  actionTrigger: null | "remove" | "transfer" | "change";
  selectedStudents: string[];
  handle_sort: any;
  sort_by: SortBy;
};

const StudentsTable: React.FC<StudentsTableProps> = ({
  students_data,
  selectStudent,
  actionTrigger,
  selectedStudents,
  sort_by,
  handle_sort,
}) => {
  const history = useHistory();
  const data = sortArray(students_data, sort_by.by, sort_by.sort);
  const columns = [
    {
      name: "LAST NAME",
      id: "last_name",
    },
    {
      name: "FIRST NAME",
      id: "first_name",
    },
    {
      name: "LOGIN CODE",
      id: "login_code",
      xs_hidden: true,
    },
    {
      name: "CLASS PERIOD",
      id: "class_id",
      xs_hidden: true,
    },
    {
      name: "LOGGED",
      id: "minutes",
    },
    {
      name: "LAST SEEN",
      id: "last_login",
      xs_hidden: true,
    },
  ];

  const gotToStudent = (ev: { currentTarget: HTMLTableRowElement }) => {
    const student_id = ev.currentTarget.getAttribute("data-student-id");
    if (actionTrigger) {
      selectStudent(student_id);
      return false;
    }
    history.push(`/student/${student_id}`);
  };

  return (
    <table className="table bg-white table-hover" id="stuents_table">
      <thead>
        <tr>
          {columns.map((column) => (
            <ThSort
              key={column.name.split(" ").join("_")}
              title={column.name}
              id={column.id}
              type={sort_by.by === column.id ? sort_by.sort : undefined}
              handle_sort={handle_sort}
              className={isMobile && column.xs_hidden ? "d-none-portrait" : ""}
            />
          ))}
          <th className="text-center d-none-portrait">
            {actionTrigger ? "SELECT" : "ACTIONS"}
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => {
          const selected_student = selectedStudents.findIndex(
            (sid) => sid === row.id,
          );
          return (
            <tr
              key={`student_list_${row.id}`}
              id={`${row.name.toLocaleLowerCase().split(" ").join("")}_row`}
              onClick={gotToStudent}
              data-student-id={row.id}
            >
              <td>
                {row.last_name}

                <span className="d-block text-muted d-md-none">
                  {row.login_code}
                </span>
              </td>
              <td>{row.first_name}</td>
              <td
                id={`${row.name.toLocaleLowerCase().split(" ").join("")}_code`}
                className="d-none-portrait"
              >
                {row.login_code}
              </td>
              <td className="xs_hidden">{row.class ? row.class.name : "-"}</td>
              <td>
                <small>
                  <b>{row.minutes}</b> selected timeframe
                  <br />
                  <span className="opacity_6">
                    <b>{row.semester_minutes}</b> lifetime
                  </span>
                </small>
              </td>
              <td className="xs_hidden">
                {row.last_login ? (
                  toDate(row.last_login)
                ) : (
                  <span className="text-muted">Not logged</span>
                )}
              </td>
              {actionTrigger ? (
                <td className="text-center">
                  <button
                    className="btn no_focus"
                    onClick={() => {
                      selectStudent(row.id);
                    }}
                    data-student={row.id}
                  >
                    <span className="fa-stack fa-1x">
                      <i
                        className={`far fa-square fa-stack-2x ${
                          selected_student >= 0 ? "opacity_8" : "opacity_5"
                        }`}
                      ></i>
                      <i
                        className={`fa-stack-1x ${
                          selected_student >= 0
                            ? actionTrigger === "remove"
                              ? "far fa-times text-danger"
                              : "far fa-check text-success"
                            : ""
                        } `}
                      ></i>
                    </span>
                  </button>
                </td>
              ) : (
                <td>
                  <Link
                    to={`/student/${row.id}`}
                    className="btn btn-dark btn-block green_outline_gray xs_hidden"
                  >
                    Manage
                  </Link>
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default StudentsTable;
